module.exports = __webpack_public_path__ + "static/img/seleccion-2.a0d50f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/seleccion-2.jpg
// module id = DvnL
// module chunks = 1